<template>
  <form-field
    :validation-errors="validationErrors"
    :label-for="forId"
    :help-text="helpText"
  >
    <template v-if="description">
      <div class="flex flex-vertical-center">
        <div class="description">
          <p class="description_label" :class="{'description_label--small': smallLabel}">{{ label }}</p>
          <p class="description_content">{{ description }}</p>
        </div>

        <div>
          <b-switch
            v-bind="$attrs"
            :value="value"
            :true-value="trueValue"
            :false-value="falseValue"
            :id="forId"
            @input="handleInput"
            :size="size"
            expanded
            :disabled="disabled"
          ></b-switch>
        </div>
      </div>
    </template>

    <template v-else>
      <!-- https://buefy.org/documentation/switch  -->
      <b-switch
        v-bind="$attrs"
        :value="value"
        :true-value="trueValue"
        :false-value="falseValue"
        :id="forId"
        @input="handleInput"
        :size="size"
        expanded
        :class="{'deal_switch': isDealSwitch}"
        :left-label="isLeftLabel"
        :disabled="disabled"
      >
        {{label}}
      </b-switch>
    </template>
  </form-field>
</template>
<script>
import FormField from "./FormField";
import {FormFieldMixin} from "./FormField.mixin";

export default {
  name: "FormFieldSwitch",
  components: {FormField},
  mixins: [FormFieldMixin],
  props: {
    value: {},
    label: {
      type: String,
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    validationErrors: {
      type: [String, Array, undefined],
    },
    helpText: {
      type: String
    },
    description: {
      type: String
    },
    size: {
      type: String,
      default: 'is-small'
    },
    smallLabel: {
      type: Boolean,
      default: false
    },
    trueValue: {
      type: [String, Number, Boolean],
      default: true
    },
    falseValue: {
      type: [String, Number, Boolean],
      default: false
    },
    isLeftLabel: {
      type: Boolean,
      default: false
    },
    isDealSwitch: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      forId: this.$utils.generateClientId(),
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
      this.$emit('change', val);
      this.$emit('selected', val);
      this.emitGlobalFieldChangeEvent();
    },
  }
}
</script>
<style lang="scss" scoped>
// Due to how Buefy works these styles must be in global styles

.description {
  padding-right: 0.75rem;

  &_label {
    margin-bottom: 4px;

    &--small {
      font-size: 0.875rem;
      font-weight: normal;
    }
  }

  &_content {
    padding-left: 0.25rem;
    font-size: 0.75rem;
    line-height: 1.3;
  }
}
</style>
